module.exports = __webpack_public_path__ + "img/pleasure-icon-9.fb2ab662.svg";